import React from 'react';
import style from './ImageSlide.module.css';
import IconList from '../../Features/IconList/IconList';

function ImageSlide({ slide, currentSlide, totalSlides }) {
  return (
    <div className={style.imageSlideContainer}>
      <img src={slide.media.src} alt={slide.title} className={style.imageStyle} />
      <div className={style.textContainer}>
        <div className={style.pagination}>
          {currentSlide + 1} / {totalSlides}
        </div>
        <h1 dangerouslySetInnerHTML={{ __html: slide.title }}></h1>
        <p dangerouslySetInnerHTML={{ __html: slide.description }}></p>
        {slide.list && <IconList list={slide.list} />}
      </div>
    </div>
  );
}

export default ImageSlide;